export default __webpack_public_path__ + "static/media/icon-bootstrap.68a6c9f8.png";